import useGetCustomerRepReport from '../hooks/useGetCustomerRepReport'
import {CustomerRepReportContext} from '../context'
import {Pagination} from '../../../utils/pagination'
import {KTCard} from '../../../_metronic/helpers'
import CustomerRepReportHeader from '../sections/header/CustomerRepReportHeader'
import CustomerRepReportTable from '../sections/table/CustomerRepReportTable'
import useGetSalesRepTypeDropdown from '../hooks/useGetSalesRepTypeDropdown'
import useGetEntityPerformanceChartData from '../hooks/useGetEntityPerformanceChartData'
import useGetProfitTrend from '../hooks/useGetProfitTrend'

function CustomerRepReport() {
  const {
    reportData,
    isLoading,
    onSearch,
    onSortingChange,
    onPageChange,
    pagination,
    onDateChange,
    filters,
    onChangeSalesRepTypeFilter,
  } = useGetCustomerRepReport()

  const {
    entityPerformanceChartData,
    isLoading: isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('sales_rep')

  const {salesRepTypes, isLoading: isSalesRepDropdownLoading} = useGetSalesRepTypeDropdown()

  const {
    profitTrendChartData,
    kpiData: profitTrendKpiData,
    weeklyBreakdownData: profitTrendWeeklyBreakdownData,
    isLoading: isProfitTrendDataLoading,
    onProfitTrendIdChange,
  } = useGetProfitTrend('sales_rep')

  const contextValue = {
    reportData,
    isLoading,
    filters,
    onSearch,
    onSortingChange,
    onPageChange,
    onDateChange,
    onChangeSalesRepTypeFilter,

    salesRepTypes,
    isSalesRepDropdownLoading,

    entityPerformanceChartData,
    isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,

    // Profit Trend Modal Data
    profitTrendChartData,
    profitTrendKpiData,
    profitTrendWeeklyBreakdownData,
    isProfitTrendDataLoading,
    onProfitTrendIdChange,
  }

  return (
    <KTCard>
      <CustomerRepReportContext.Provider value={contextValue}>
        <CustomerRepReportHeader />
        <CustomerRepReportTable />
        <Pagination pagination={pagination} onPageChange={onPageChange} />
      </CustomerRepReportContext.Provider>
    </KTCard>
  )
}

export default CustomerRepReport
